/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import LoadIcon from '../../../LoadIcon';

const RadioList = ({
  handlerSetComponents, components, id, type,
}) => {
  const initialState = {
    type,
    limit: 8,
    showToggleView: false,
    activeView: 'grid',
  };
  const [limit] = useState(20);
  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);

  const setLimitHandler = (e) => {
    const { name, value } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: Number(value),
    };
    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  const toggleSwitchHandler = (e, bool) => {
    const { name } = e.target;
    const { component } = components[index];

    const comp = {
      ...component,
      [name]: bool,
    };
    setState(comp);
    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    setIndex(componentIndex);
    // Check if we are reading a component already done or if we are creating a new one
    if (component) {
      const comp = { ...component };
      setState(comp);
    } else {
      const componentObj = {
        id,
        component: state,
      };
      handlerSetComponents(componentObj, componentIndex);
    }
  }, [components]);

  return (
    <div className="flex flex-row ml-10 items-center bg-greyFilter rounded-br-lg">
      <div className="my-2 pt-0 ml-4 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex justify-center items-between">
        <div>
          Nr of items:
          <select name="limit" id="limit" onChange={setLimitHandler} value={state.limit} className="ml-1">
            {
                    Array.from(Array(limit + 1)).map((_, ind) => (
                      <option value={ind} key={ind}>
                        {' '}
                        {ind}
                        {' '}
                      </option>
                    ))
                  }
          </select>
        </div>
      </div>
      <div className="ml-2 pb-0 text-xs uppercase pl-1 text-black font-americaMonoRegular flex items-center">
        Show ToggleView
        <label className="switch mb-0 pb-0 h-6 ml-2">
          <input
            name="showToggleView"
            checked={!state.showToggleView}
            onChange={e => toggleSwitchHandler(e, !state.showToggleView)}
            type="checkbox"
            id="switch-button"
          />
          <div className="switch-slider btn-yn switch-round" />
        </label>
      </div>
    </div>
  );
};

RadioList.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
};


export default RadioList;
